import React from 'react';
import App from './App';
import {createRoot} from "react-dom/client";
import {initTheme} from "./utils/storage/Theme";

initTheme();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);
